import React from 'react';
import Hero from '../Components/Hero/Hero';
import Newcollections from '../Components/Newcollections/Newcollections';

import Newsletter from '../Components/Newsletter/Newsletter';

const Shope = () => {
  return (
    <div>
      <Hero />
      <Newcollections/>
      <Newsletter />
    </div>
  );
};

export default Shope;
